"use strict";

require("../../style/index.less");

require("./index.less");

require("../../menu/style");

require("../../dropdown/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/breadcrumb/style/index.js
// module id = 1171
// module chunks = 1